import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdRoundValue',
  standalone: true,
})
export class SdRoundValuePipe implements PipeTransform {
  transform(num: number | null, precision: number = 0): string {
    if (num === null) return '0';

    const tho = 10 ** precision;

    const numberWithCommas = (x: number): string => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    if (precision <= 0) {
      return numberWithCommas(Math.round(num));
    }

    return numberWithCommas(Math.round(num * tho));
  }
}
